export default __webpack_public_path__ + "static/media/webdragon.f2b8a12b.png";